import {ACCOUNT, RESET} from './mutation-types'

export default {
  createAccount ({commit}, decodedToken) {
    commit(ACCOUNT, decodedToken)
  },
  logout ({commit}) {
    commit(RESET)
  }
}



// WEBPACK FOOTER //
// ./src/app/store/modules/account/actions.js